/* global axios */

const whatsappTemplatesAPI = {
  create(accountId, { inboxId, template }) {
    return axios.post(`/api/v1/accounts/${accountId}/whatsapp_templates`, {
      template,
      inbox_id: inboxId,
    });
  },

  list(accountId, inboxId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/whatsapp_templates?inbox_id=${inboxId}`
    );
  },

  updateTemplate(accountId, templateId, { inboxId, template }) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/whatsapp_templates/${templateId}`,
      { template, inbox_id: inboxId }
    );
  },

  updateTemplateCategory(accountId, templateId, { inboxId, category }) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/whatsapp_templates/${templateId}/category`,
      { category, inbox_id: inboxId }
    );
  },
};

export default whatsappTemplatesAPI;
